import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import { Button, Tooltip } from '@mui/material';
import { debugStore } from '@stores/Debug';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import css from './AtlasButton.module.scss';

/**
 * Entry point to the Story Atlas — the full-screen narrative visualization of
 * this library (seasons → episodes → threads → scenes → shots). Gated: team
 * email domains, or the "Story Atlas" debug toggle.
 */
export const AtlasButton = observer(
  ({ libraryId, compact = false }: { libraryId: string; compact?: boolean }) => {
    const navigate = useNavigate();

    if (!debugStore.showStoryAtlas) {
      return null;
    }

    return (
      <Tooltip title="Explore this library as a story atlas" placement="top" arrow>
        <Button
          onClick={() => navigate(`/atlas/${libraryId}`)}
          className={classNames(css.atlasButton, { [css.compact]: compact })}
          disableRipple
          aria-label={compact ? 'Story atlas' : undefined}
          startIcon={<AutoStoriesRoundedIcon className={css.atlasIcon} />}
        >
          {!compact && 'Atlas'}
        </Button>
      </Tooltip>
    );
  },
);
